import React, { Component } from 'react';
import Modal from 'react-modal';
import { withRouter } from 'react-router-dom';
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils';
import MessageCreateModalUI from './MessageCreateModalUI';

class MessageCreateModalSF extends Component {
  constructor(props) {
    super(props);

    this.state = {
      successMsg: null,
      errorList: null,
      submitted: false,
      subject: '',
      subjectError: null,
      message: '',
      messageError: null,
      emailTo: '',
      emailToError: null,
      emailCc: '',
      emailCcError: null,
      emailBcc: '',
      emailBccError: null,
    };
  }

  render() {
    return (
      <MessageCreateModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        onSubmit={this.onSubmit}
        onCancelClick={this.onCreateMessageCancel}
        messageCreateMode={this.props.messageCreateMode}
        submitted={this.state.submitted}
        //
        subject={this.state.subject}
        onSubjectChange={(event) => this.setState({ subject: event.target.value })}
        subjectError={this.state.subjectError}
        setSubjectError={(error) => this.setState({ subjectError: error })}

        message={this.state.message}
        onMessageChange={(event) => this.setState({ message: event.target.value })}
        messageError={this.state.messageError}
        setMessageError={(error) => this.setState({ messageError: error })}

        emailTo={this.state.emailTo}
        onEmailToChange={(event) => this.setState({ emailTo: event.target.value })}
        emailToError={this.state.emailToError}
        setEmailToError={(error) => this.setState({ emailToError: error })}

        emailCc={this.state.emailCc}
        onEmailCcChange={(event) => this.setState({ emailCc: event.target.value })}
        emailCcError={this.state.emailCcError}
        setEmailCcError={(error) => this.setState({ emailCcError: error })}

        emailBcc={this.state.emailBcc}
        onEmailBccChange={(event) => this.setState({ emailBcc: event.target.value })}
        emailBccError={this.state.emailBccError}
        setEmailBccError={(error) => this.setState({ emailBccError: error })}

      />
    );
  }

  componentDidMount() {
    Modal.setAppElement('body');
  }

  onCreateMessageCancel = () => {
    this.setState({
      subject: null,
      message: null,
      emailTo: null,
      emailCc: null,
      emailBcc: null,
    })
    this.props.onCreateMessageCancel();
  };

  onSubmit = () => {
    if (this.state.submitted) return;

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true,
    });

    RestApiUtils.post(
      this.props.context,
      `/api/su/accounts/${this.props.account.accountId}/messageApprovals`,
      this.onSubmitCallback,
      {
        message: this.state.message,
        subject: this.state.subject,
        emailTo: this.state.emailTo,
        emailCc: this.state.emailCc,
        emailBcc: this.state.emailBcc
      }
    );
  };

  onSubmitCallback = (response) => {
    let errorList = [];
    if (response && response.errorList) {
      response.errorList.forEach((error) => {
        errorList.push(error.message);
      });
    }

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false,
    });

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({ successMsg: null });
        this.onCreateMessageCancel();
        this.props.onRefreshClick();
      }, 2000);
    }
  };

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList });
  };
}

export default withRouter(MessageCreateModalSF);
